// extracted by mini-css-extract-plugin
module.exports = {"form":"LoginForm_form__JMdba","perdeu":"LoginForm_perdeu__3wr0G","cadastro":"LoginForm_cadastro__3F3xU","subtitle":"LoginForm_subtitle__2Sq9l"};